import { highSeasonRanges } from '../config/highSeasonRanges';
// import { extendMoment } from 'moment-range';
// const momentEaster = extendMoment(require('moment-easter'));

let isHighSeason = (start, end) => {
    let isHighSeason = false;
    // let isInHolyWeek = start.within(getHolyWeekRange(start.year())) || end.within(getHolyWeekRange(end.year()));

    for(let season of highSeasonRanges){
        if(start.within(season) || end.within(season)){
            isHighSeason = true;
            break;
        }
    }

    return isHighSeason;
        // || isInHolyWeek;
};

// let getHolyWeekRange = (year) => {
//     let p = momentEaster.easter(year);
//     let r = momentEaster(p).subtract(1, 'week');
//     return momentEaster.range(r, p);
// };

export default isHighSeason;


// WEBPACK FOOTER //
// ./src/utils/isHighSeason.js